import type { DueBadge, DueFilter } from "@icraftx/shared/v1";

/** Thin lifecycle docs (payments / returns / GR) — plan/30. */
export type PostedDocLifecycleFilter = "all" | "draft" | "posted" | "void";

/** Active customer/supplier filter from a list cell click. */
export type PartyFilter = { id: string; name: string };

/** Clicking an already-active filter value clears it. */
export function toggleFilter<T extends string>(
  current: T,
  next: T,
  all: T,
): T {
  return current === next ? all : next;
}

/** Toggle party filter — same id clears. */
export function togglePartyFilter(
  current: PartyFilter | null,
  next: PartyFilter,
): PartyFilter | null {
  return current?.id === next.id ? null : next;
}

/** Map a due badge to the closest list due filter (plan/30). */
export function dueBadgeToFilter(badge: DueBadge): DueFilter | null {
  if (badge.kind === "overdue") return "overdue";
  if (badge.kind === "today") return "this_week";
  if (badge.kind === "upcoming" && badge.days != null && badge.days <= 6) {
    return "this_week";
  }
  if (badge.kind === "none") return "none";
  return null;
}
